export default {
  title: 'اتصل بالدعم',
  form: {
    firstName: 'اسم شخصي',
    lastName: 'اسم العائلة',
    nickname: 'الكنية',
    phoneNumber: 'رقم الهاتف',
    email: 'البريد الإلكنروني',
    emailVerification: 'تأكيد البريد الالكتروني',
    subject: {
      label: 'الموضوع',
      options: ['المشكلة', 'الفاتورة', 'انقطع الاتصال', 'تعليق', 'تحسين'],
    },
    message: 'الرسالة',
    button: 'يرسل',
  },
  errors: {
    requiredField: 'هذه الخانة مطلوبة.',
    sendFailed: 'ممثلي الدعم لدينا سوف يتواصل معكم في أقرب وقت',
  },
  success: {
    title: 'لقد فهمت!',
    message: 'ممثلي الدعم لدينا سوف يتواصل معكم في أقرب وقت',
  },
};
